import getStore from '../store/store';

export default function isSpotlightRow(rowKey: string): boolean {
    return getStore().spotlightItems.some(spotlightItem => spotlightItem.rowKey === rowKey);
}
